import React, { useEffect, useState } from 'react';
import { Modal, Button, Col, Row, Form } from 'react-bootstrap';
import TauriImage from '../../../TauriImage/TauriImage';
import './ApprovedLeaveModal.css';
import TauriLoader2 from '../../../TauriLoader2/TauriLoader2';

const ApprovedLeaveModal = ({ show, onHide, item }) => {

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));
    const [remarks, setRemarks] = useState('');

    useEffect(() => {
        setRemarks('');
    }, [item])

    return (
        <Modal className='approved-leave-modal' show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                APPROVED LEAVE
            </Modal.Header>
            <Modal.Body>
                <div className="leave-section">
                    <div className="field-group">
                        <label className="field-label">EMPLOYEE NAME</label>
                        <div className="field-value">{item?.Name}</div>
                    </div>

                    <Row className="mt-3">
                        <Col>
                            <div className="field-group">
                                <label className="field-label">LEAVE DATE</label>
                                <div className="field-value">{item?.leaveDate || 'Aug 1, 2025'}</div>
                            </div>
                        </Col>
                        <Col>
                            <div className="field-group">
                                <label className="field-label">TYPE OF LEAVE</label>
                                <div className="field-value">{item?.typeOfLeave || 'Vacation Leave'}</div>
                            </div>
                        </Col>
                    </Row>

                    <div className="field-group mt-3">
                        <label className="field-label">REMARKS</label>
                        <Form.Control
                            type="text"
                            className="remarks-input"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="">
                <Button className='btn-reject d-flex' >
                    <span className="text-nowrap">REJECT</span>
                </Button>
                <Button className="btn-approve d-flex" >
                    <span className="text-nowrap">Approve</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ApprovedLeaveModal;
